<template>
    <v-container class="fill-height" style="display: block;" fluid>
        <v-row>
            <v-col cols="12" lg="6">
                <v-card outlined class="card">
                    <v-card-title>
                        Preferences
                        <v-icon class="setting-scope-icon">mdi-account</v-icon>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="card-body">
                        <v-row>
                            <v-col cols="12">
                                <v-select label="Start Page" v-model="$props.preferences.startPage" color="#c42111" :items="pages" item-text="text" item-value="name" height="50">
                                    <template slot="item" slot-scope="data">
                                        <v-icon class="mr-4">{{data.item.icon}}</v-icon>  {{data.item.text}}
                                    </template>
                                    <template class="mt-4" slot="selection" slot-scope="data">
                                        <v-icon class="mr-2 mt-3">{{data.item.icon}}</v-icon>  <span class="mt-3">{{data.item.text}}</span>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12">
                                <span>Thin Scrollbar Style</span>
                                <v-switch v-model="$props.preferences.thinScrollbar" label="Off/On" color="#c42111" />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field color="#c42111" type="number" min="0" max="525600" label="Inactivity Timeout(min)" :hint="inactivityTimeoutHint" persistent-hint v-model="$props.preferences.inactivityTimeoutMin" :disabled="!$store.state.user.user_data.is_customer_admin" :rules="[$store.state.validationFuncs.nonNegInteger($props.preferences.inactivityTimeoutMin, 'value')]" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" lg="6">
                <v-card outlined class="card">
                    <v-card-title>
                        Login Page
                        <v-icon class="setting-scope-icon">mdi-account-group</v-icon>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="card-body">


                        <login-page></login-page>


                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import LoginPage from "@/components/Settings/LoginPage";
export default {
    name: 'Preferences',
    props: ['preferences'],
    components: {
        LoginPage
    },
    data: () => ({
        pages: [
            { icon: 'mdi-bell-check', text: 'Alarm Modifications', name: 'alarmmodifications' },
            { icon: 'mdi-bell-ring', text: 'Alarms', name: 'alarms' },
            { icon: 'mdi-cube', text: 'Common Objects', name: 'sitebookobjects' },
            { icon: 'mdi-monitor-dashboard', text: 'Cloud Dashboard', name: 'dashboard' },
            { icon: 'mdi-google-maps', text: 'Geo Map', name: 'geomap' },
            { icon: 'mdi-home', text: 'Home', name: 'home' },
            { icon: 'mdi-sticker-alert', text: 'Issues', name: 'issues' },
            { icon: 'mdi-playlist-edit', text: 'Network Categories', name: 'networkcategories' },
            { icon: 'mdi-sitemap', text: 'Network Maps', name: 'networkmaps' },
            { icon: 'mdi-phone-ring-outline', text: 'Paging Rules', name: 'pagingrules' },
            { icon: 'mdi-account-switch', text: 'Paging Substitutions', name: 'pagingsubstitutions' },
            { icon: 'mdi-history', text: 'Report History', name: 'reporthistory' },
            { icon: 'mdi-chart-bar', text: 'Reports', name: 'reports' },
            { icon: 'settings', text: 'Settings', name: 'settings' },
            { icon: 'mdi-book-open', text: 'Site Book', name: 'sitebook' },
            { icon: 'mdi-vector-polygon', text: 'Site Groups', name: 'sitegroups' },
            { icon: 'mdi-radioactive', text: 'Sites', name: 'sites' },
            { icon: 'mdi-email-edit', text: 'SMTP', name: 'smtp' },
            { icon: 'mdi-timetable', text: 'Special Reports', name: 'specialreports' },
            { icon: 'mdi-clipboard-text', text: 'Threshold Profiles', name: 'thresholdprofiles' },
            { icon: 'mdi-file-tree', text: 'Trees', name: 'sitebooktrees' },
            { icon: 'mdi-account-group', text: 'User Groups', name: 'usergroups' },
            { icon: 'mdi-card-account-details', text: 'User Thresholds', name: 'userthresholds' },
            { icon: 'mdi-account-multiple', text: 'Users', name: 'users' },
        ],

        inactivityTimeoutHint: "Threshold of consecutive minutes with the application not being in view before the application will enter into an inactivity state to conserve resources. Once the application is brought into view again it will refresh itself. Set to '0' to turn off."
    }),

    computed: {
    },

    methods: {
    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .card {
        overflow-y: auto;
        max-height: calc(100vh - 224px);
        /* height: calc(100vh - 242px); */
        position: relative;
    }

    .card-body {
        overflow-y: auto;
        /* height: calc(100% - 65px); */
        max-height: calc(100vh - 310px);
        position: relative;
    }

</style>
